"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveRefundPolicy = exports.generateRefundPolicy = exports.validateRefundPolicy = void 0;
const i18next_1 = __importDefault(require("i18next"));
const api_1 = require("@/api");
const string_utils_1 = require("@/common/string_utils");
const validateRefundPolicy = (refundPolicy) => {
    let validation;
    if (refundPolicy.length < 2) {
        validation = `${i18next_1.default.t('교환/환불 안내를 입력해주세요')}`;
    }
    return validation;
};
exports.validateRefundPolicy = validateRefundPolicy;
const generateRefundPolicy = (refundPolicy) => {
    return (0, string_utils_1.removeTags)(refundPolicy);
};
exports.generateRefundPolicy = generateRefundPolicy;
const saveRefundPolicy = ({ isEdit, keepingRefundPolicy, refundPolicy, originRefundPolicy, }) => __awaiter(void 0, void 0, void 0, function* () {
    if (!isEdit && keepingRefundPolicy && refundPolicy !== originRefundPolicy) {
        return yield (0, api_1.postData)('/api/v1/store/refund_policy', { refund_policy: refundPolicy });
    }
});
exports.saveRefundPolicy = saveRefundPolicy;
